"use client";

import { useBookmarkStore } from "@/stores/bookmarkStore";
import { useMapStore } from "@/stores/mapStore";
import { useMapUIStore } from "@/stores/mapUIStore";
import { useReSearchStore } from "@/stores/reSearchStore";
import { useSearchConditionStore } from "@/stores/searchConditionStore";
import Image from "next/image";
import Link from "next/link";
import { useRouter } from "next/navigation";

export default function Logo() {
  const router = useRouter();

  // Store actions for state reset
  const {
    hideSidebar,
    clearCountry,
    clearSelectedPin,
    clearCheckedPin,
    clearHoveredPin,
    setActivePopupPoi,
    setHoverPopupPoi,
    resetClusterState,
    resetCamera,
  } = useMapUIStore();
  const { resetSearchState } = useReSearchStore();
  const { resetCondition, setIsCompletePrompt, setUserCountry } =
    useSearchConditionStore();
  const { resetAll, setShowHeatMap, setShowRadius, setLocalPeopleData } =
    useMapStore();
  const { setFilterBookmarkedOnly } = useBookmarkStore();

  const handleLogoClick = (e: React.MouseEvent) => {
    e.preventDefault();

    // Reset all UI states
    hideSidebar();
    clearCountry();
    clearSelectedPin();
    clearCheckedPin();
    clearHoveredPin();
    setActivePopupPoi(null);
    setHoverPopupPoi(null);
    resetClusterState();
    // Reset camera to default to let MapView handle initialization properly
    resetCamera();

    // Reset search states
    resetSearchState();
    resetCondition();
    setIsCompletePrompt(false);
    setUserCountry(""); // Reset LocationSelector

    // Reset map states
    resetAll();
    setShowHeatMap(false);
    setShowRadius(false);
    setLocalPeopleData([]);

    // Reset media list
    setFilterBookmarkedOnly?.(false);

    // Navigate to home page
    router.replace("/");
  };

  return (
    <h1>
      <div className="flex items-center gap-3">
        <Link href={"/"} onClick={handleLogoClick}>
          <Image
            className="h-5"
            width={74}
            height={20}
            alt="AdEx Logo"
            src={"/images/logo.svg"}
          />
        </Link>
      </div>
    </h1>
  );
}
